export const STRINGS = {
  navigationItems: {
    start: 'Start',
    matchcard: 'Matchcard',
    roster: 'Roster',
    wrestler: 'Wrestler',
    aboutUs: 'Über uns',
    events: 'Events',
    training: 'Training',
    supporter: 'Supporter',
    contact: 'Kontakt',
  },
  collectorsMedal: 'Collector',
}
